import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import CMSDashboard from "./pages/CMSDashboard";
import DynamicPage from "./pages/DynamicPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import DriverLandingPage from "./pages/DriverLandingPage";
import DriverLoginPage from "./pages/DriverLoginPage";
import DriverSignupPage from "./pages/DriverSignupPage";
import DriverDashboardPage from "./pages/DriverDashboardPage";
import TrackingPage from "./pages/TrackingPage";
import LiveTrackingPage from "./pages/LiveTrackingPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  const demoUser = { id: "demo-user-123", phone: "Demo User", role: "user" };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<UserDashboard user={demoUser} />} />
          <Route path="/user" element={<UserDashboard user={demoUser} />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route path="/admin/cms" element={<CMSDashboard />} />
          <Route path="/booking-success" element={<PaymentSuccess />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/driver" element={<DriverLandingPage />} />
          <Route path="/driver/login" element={<DriverLoginPage />} />
          <Route path="/driver/signup" element={<DriverSignupPage />} />
          <Route path="/driver/dashboard" element={<DriverDashboardPage />} />
          <Route path="/track/:bookingId" element={<TrackingPage user={demoUser} />} />
          <Route path="/live-track/:bookingId" element={<LiveTrackingPage />} />
          <Route path="/:slug" element={<DynamicPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
